/** Мутация изменения доступа к просмотру проекта. */
import { useMutation } from "@tanstack/react-query";
import { Api, type UpdateProjectSharingRequest } from "@/api";
import { projectsKeys } from "./keys";

type ProjectPath = { id: string };
type UpdateProjectSharingArgs = [path: ProjectPath, data: UpdateProjectSharingRequest];

export const useUpdateProjectSharing = () => {
	const mutation = useMutation({
		mutationFn: ([path, data]: UpdateProjectSharingArgs) =>
			Api.Project.putApiProjectsSharingById(path, data),
		mutationKey: projectsKeys.updateSharing,
	});

	return {
		execute: async (...args: UpdateProjectSharingArgs) => {
			return mutation.mutateAsync(args);
		},
		isPending: mutation.isPending,
	};
};
